import React from 'react'

const DashboardSingleProfessional = () => {
	return <div>DashboardSingleProfessional</div>
}

export default DashboardSingleProfessional
